import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Calories = ({ calories, typeVariant }) => (
  <Typography component="p" variant={typeVariant} data-testid="calories-field">
    {calories} Cal
  </Typography>
);

Calories.propTypes = {
  calories: PropTypes.string.isRequired,
  typeVariant: PropTypes.string
};

export default Calories;
